import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import Divider from 'src/components/ResumeCard/Divider';
import translation from 'src/components/translation';
import type { StringWithTrl } from 'src/models/resumeCard';

import Field from 'src/components/ResumeCard/Body/Field';

interface Props {
    professionalRoles?: StringWithTrl[];
}

const TrlKeys = {
    title: 'resume.search.field.professional_role',
};

const ProfessionalRoles: TranslatedComponent<Props> = ({ professionalRoles, trls }) => {
    if (!professionalRoles?.length) {
        return null;
    }
    return (
        <Field title={trls[TrlKeys.title]} dataQaName="professional-roles">
            <div>
                {professionalRoles.map(({ trl, string }, index) => (
                    <span data-qa="resume-serp_resume-item-content" key={string}>
                        {trl}
                        {professionalRoles.length - 1 === index ? null : <Divider />}
                    </span>
                ))}
            </div>
        </Field>
    );
};

export default translation(ProfessionalRoles);
